(() => {
  'use strict';
  if (window.__bearSinisterFlyer) return;
  window.__bearSinisterFlyer = true;
  const controllers = new WeakMap();
  function init(root) {
    if (controllers.has(root)) return;
    const trigger = root.querySelector('[data-bs3-flyer-trigger]');
    const dialog = root.querySelector('[data-bs3-flyer-dialog]');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
    const image = dialog.querySelector('[data-bs3-flyer-image]');
    const closeButton = dialog.querySelector('[data-bs3-flyer-close]');
    const abort = new AbortController();
    const options = {signal: abort.signal};
    let originalReady = false;
    let originalLoading = false;
    let disposed = false;

    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (dialog.open) return;
      // Show the already loaded page image immediately, then decode the exact original.
      if (!originalReady) image.src = trigger.querySelector('img').currentSrc || trigger.querySelector('img').src;
      dialog.showModal();
      document.documentElement.classList.add('bs3-flyer-open');
      closeButton.focus({preventScroll: true});
      if (!originalReady && !originalLoading) {
        originalLoading = true;
        const original = new Image();
        original.src = trigger.href;
        original.decode().then(() => {
          if (!disposed) {image.src = original.src; originalReady = true;}
        }).catch(() => {
          // Keep the visible web rendition if the original cannot be loaded.
        }).finally(() => {originalLoading = false;});
      }
    }, options);
    closeButton.addEventListener('click', () => dialog.close(), options);
    // A press must start and end on the backdrop, not on artwork dragged outside it.
    let backdropPress = false;
    dialog.addEventListener('pointerdown', event => {backdropPress = event.target === dialog;}, options);
    dialog.addEventListener('click', event => {
      if (backdropPress && event.target === dialog) dialog.close();
      backdropPress = false;
    }, options);
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('bs3-flyer-open');
      if (trigger.isConnected) trigger.focus({preventScroll: true});
    }, options);
    // Native dialog provides Escape dismissal and makes the underlying page inert.
    controllers.set(root, () => {
      disposed = true;
      abort.abort();
      if (dialog.open) dialog.close();
      document.documentElement.classList.remove('bs3-flyer-open');
      trigger.removeAttribute('aria-haspopup');
      trigger.removeAttribute('aria-controls');
      controllers.delete(root);
    });
  }
  const boot = scope => scope.querySelectorAll('.bs3').forEach(init);
  const bootParsed = () => {
    if (document.readyState === 'loading') return;
    document.removeEventListener('readystatechange', bootParsed);
    boot(document);
  };
  if (document.readyState === 'loading') document.addEventListener('readystatechange', bootParsed);
  else bootParsed();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.bs3').forEach(root => controllers.get(root)?.()));
})();
